import {
  createContext,
} from 'react';

export type ReadonlyContextProps = {
  readonly: boolean;
};

export const ReadonlyContext = createContext<ReadonlyContextProps>({
  readonly: false,
});
